/** Provider that blocks Free-tier project creation and shows WallModal. */
// @ts-check
import { useCallback, useState } from 'react';
import { useTier } from '@/features/tier/useTier';
import { useTasksContext } from '@/features/tasks/context/TasksContext.def';
import WallModal from '@/features/wall/components/WallModal';
import { ProjectLimitWallContext } from '@/features/wall/context/ProjectLimitWallContext.def';
import { shouldBlockNewProjectCreation } from '@/features/wall/utils/projectLimitUtils';

export function ProjectLimitWallProvider({ children }) {
  const { tier } = useTier();
  const { projectDisplayMap, allProjectMap } = useTasksContext();
  const [open, setOpen] = useState(false);

  const guardProjects = /** @type {(projectTerms: string[] | null | undefined) => boolean} */ (
    useCallback(
      (projectTerms) => {
        const blocked = shouldBlockNewProjectCreation({
          tier,
          activeProjectCount: projectDisplayMap.size,
          projectTerms,
          knownProjectMap: allProjectMap,
        });
        if (blocked) {
          setOpen(true);
          return false;
        }
        return true;
      },
      [tier, projectDisplayMap, allProjectMap],
    )
  );

  const closeWall = /** @type {() => void} */ (useCallback(() => setOpen(false), []));

  return (
    <ProjectLimitWallContext.Provider value={{ guardProjects }}>
      {children}
      <WallModal
        open={open}
        onClose={closeWall}
        wallType="project_limit"
      />
    </ProjectLimitWallContext.Provider>
  );
}
